module.exports = __webpack_public_path__ + "img/logo-resolve.9701f407.svg";